import { render, staticRenderFns } from "./config.vue?vue&type=template&id=f0a354da&scoped=true"
import script from "./config.vue?vue&type=script&lang=js"
export * from "./config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a354da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Developer\\Projects\\new-lottery-assistant-qd\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a354da')) {
      api.createRecord('f0a354da', component.options)
    } else {
      api.reload('f0a354da', component.options)
    }
    module.hot.accept("./config.vue?vue&type=template&id=f0a354da&scoped=true", function () {
      api.rerender('f0a354da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/fortune/product/config.vue"
export default component.exports